import StorageKeys from "../../../const/StorageKeys";
import CacheStorage from "../../../service/storage/CacheStorage";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { BranchChatListModel } from "../../../model/branch/BranchChatsModel";
import ShowToast from "../../../widget/common/ui/Toast";

const BranchDeptChatsProvider = new (class BranchDeptChatsProvider {
  getChatListAPI = async (): Promise<BranchChatListModel | null> => {
    ApiUrls.init();

    const barnchId: string = CacheStorage.getValue(StorageKeys.branch_id);
    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}search/get_chats_list`;
    const body: any = {
      account_id: accountId,
      branch_id: barnchId,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const branchChatListModel: BranchChatListModel = response;
        return branchChatListModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default BranchDeptChatsProvider;
